// extracted by mini-css-extract-plugin
export default {"imgdiv":"_610803fedc _7600bf743b","img":"bbc820849c _505c61e04c"};